import { inject, observer } from "mobx-react";
import React from "react";
import { Button, Offcanvas, Spinner } from "react-bootstrap";
import Form from "react-bootstrap/Form";

export interface drawerButtonProps {
    title: string;
    onClick: (e?: React.FormEvent) => void;
    disabled?: boolean;
}

interface LateralDrawerProps {
    isOpen: boolean;
    title: string;
    onClose: () => void;
    children: React.ReactNode;
    confirmButton?: drawerButtonProps;
    cancelButton?: drawerButtonProps;
    isLoading?: boolean;
}

@inject("coursesCatalogStore", "ingestionStore")
@observer
export class LateralDrawer extends React.Component<LateralDrawerProps> {
  render () {
      return (
        <Offcanvas
          className="drawer"
          size={432}
          show={this.props.isOpen}
          onHide={this.props.onClose}
          placement="end"
          scroll={true}
          backdrop={true}
        >
            <Form name="drawer-form" onSubmit={this.props.confirmButton?.onClick} className="drawer-container">
              <Offcanvas.Body>
                <div>
                  <div className="title-container">
                    <h1>
                      {this.props.title}
                    </h1>
                    <i className={"icon icon-close"} onClick={this.props.onClose} />
                  </div>
                  <div className="inputs-container">
                    {this.props.children}
                  </div>
                </div>
              </Offcanvas.Body>
              <div className="buttons-edit-container">
                {this.props.cancelButton &&
                  <Button
                    onClick={this.props.cancelButton?.onClick}
                    variant="outline-secondary"
                    disabled={this.props.cancelButton?.disabled}
                    className="cancel-button">{this.props.cancelButton?.title}
                  </Button>
                }
                {this.props.confirmButton &&
                  <Button
                    type={"submit"}
                    variant="secondary"
                    disabled={this.props.confirmButton?.disabled}
                    className="confirm-edit-button">
                    {this.props.isLoading && <Spinner size="sm" className="me-2" />}
                    {this.props.confirmButton?.title}
                  </Button>
                }
              </div>
            </Form>
        </Offcanvas>);
  }
}